const instancias = (
    {
        API_URL: process.env.REACT_APP_API_URL,
        API_URLPR: process.env.REACT_APP_API_URLPR,
        API_PORT: process.env.REACT_APP_API_PORT,
        API_URL_IPS: process.env.REACT_APP_API_URL_IPS
    }
)

export default instancias;